import React, { useEffect } from 'react';
import { styled } from "../../stitches.config"

const SeeAlsoArticlesTaboola: React.FC = () => {
    useEffect(() => {
        (window as any)._taboola = (window as any)._taboola || [];

        (window as any)._taboola.push({
            mode: 'alternating-thumbnails-a',
            container: 'taboola-below-article-streaming-widget',
            placement: 'Below Article Streaming Widget',
            target_type: 'mix',
        });

        return () => {
            (window as any)._taboola.push({ flush: true });
        };
    }, []);

    return (
        <StyledSeeAlsoArticlesTaboola>
            <div id="taboola-below-article-streaming-widget" />
            <BlackLine />
        </StyledSeeAlsoArticlesTaboola>
    );
};

const StyledSeeAlsoArticlesTaboola = styled('div', {
    margin: "20px 0",
    position: "relative",
    zIndex: 10,
});

const BlackLine = styled('div', {
    borderTop: "2px solid $grayscale100",
    width: "100%",
});

export default SeeAlsoArticlesTaboola;